import { Component, OnInit } from '@angular/core';
import { ImagePathService } from "../../../../core/common/variables/image-path.service";
import { TranslateService } from "../../../common/variables/translate-service";

@Component({
  selector: 'sen-app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  constructor(public translate: TranslateService, public imagePath: ImagePathService) { }

  ngOnInit(): void {
  }

}
